var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._b({staticStyle:{"color":"var(--v-error-base)","font-size":"12px"},attrs:{"transition":"fade-transition"}},'span',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }